import { Box, Typography } from "@mui/material";
import { StatusChip } from "../../shared/components";

export const headers = [
    { "alias_name": "id", "label": "Artefact", "display_order": 1, is_show: true },
    { "alias_name": "category", "label": "Category", "display_order": 2, is_show: true },
    { "alias_name": "version_id", "label": "Version", "display_order": 3, is_show: true },
    { "alias_name": "status", "label": "Status", "display_order": 4, is_show: true },
    { "alias_name": "days_since_upload", "label": "Days Since Upload", "display_order": 5, is_show: true },
    { "alias_name": "assigned_to", "label": "Owner", "display_order": 6, is_show: true },
    { "alias_name": "required_date", "label": "Required Date", "display_order": 8, is_show: true },
    { "alias_name": "expiry_date", "label": "Expiry Date", "display_order": 9, is_show: true },
    { "alias_name": "title", "label": "", "display_order": 10, is_show: false },
    { "alias_name": "desc", "label": "", "display_order": 11, is_show: false },
];

export const metrics = {
    "id": {
        type: "component",
        element: (row: { title: string, category: string, artefact_ref: string }) => (
            <Box display={'flex'} alignItems={'start'} flexDirection={'column'}>
                <Typography variant="caption" color="text.secondary">{row.artefact_ref}</Typography>
                <Typography variant="body2" color="text.primary">{row.title}</Typography>
                <Typography variant="caption" color="text.secondary">{row.category}</Typography>
            </Box>
        )
    },
    "category": {
        type: "component",
        element: (row: { category: string }) => (
            <StatusChip label={row.category}
                sx={{ borderRadius: '4px' }}
                color={"default"} />
        )
    },
    "status": {
        type: "component",
        element: (row: { status: string, status_display_text: string }) => (
            <StatusChip label={row.status_display_text}
                color={"amber"} />
        )
    },
   "days_since_upload": {
    type: "component",
    element: (row: { days_since_upload: number | null }) => (
        <Box display="flex" alignItems="center" justifyContent="center" marginRight={5}> 
           <Typography variant="body2" color="text.primary">
            {row.days_since_upload ?? "N/A"}
        </Typography>
        </Box>
        
    )
},
    "assigned_to": {
        type: "component",
        element: (row: { assigned_to: string }) => {
            return (
                <Box display="flex" alignItems="center" gap={1}>
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            bgcolor: "divider",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "text.primary",
                            fontSize: "0.8rem",
                            fontWeight: 600,
                            textTransform: "uppercase",
                        }}
                    >
                        {row?.assigned_to ? row?.assigned_to.split(" ").filter(Boolean).map(word => word[0].toUpperCase()).join("").slice(0, 2) : 'N/A'}
                    </Box>
                    <Typography variant="caption" color="text.primary">
                        {row.assigned_to}
                    </Typography>
                </Box>
            );
        }
    },
    "required_date": {
        type: "date"
    },
    "expiry_date": {
        type: "date"
    }
};